<template>
    <div>
        <!--Page Header-->
        <section class="page_header header_aboutus padding">
          <div class="container">
            <div class="header_content padding">
              <div class="row">
                <div class="col-md-12 text-center">
                   <h1 class="uppercase" style="font-size:50px">о нас</h1>
                   <p></p>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="page_menu">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3 class="hidden">hidden</h3>
              <ul class="breadcrumb">
                <li><a href="/" style="color: black">Главная</a></li>
                <li class="active">О нас</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

    <!--OUR BLOG-->
    <section id="blog" class="">
      <br>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="heading_space uppercase" style="color: #0060aa">окнаогонь
            </h2>
            <p class="bottom_half">Более <strong>9 лет</strong> на рынке
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p class="bottom_half">Наша компания вот уже более 9 лет выполняет изготовление и установку пластиковых и алюминиевых оконных конструкций по ценам от производителя. Мы изготавливаем пластиковые окна из лучших материалов, соответствующих принятым европейским стандартам качества. Оконные изделия компании «Окна Огонь» обеспечивают комфорт, надежность и высокое качество, что обеспечит Вашему дому тепло в любое время года. надежная звуко и теплоизоляция, защита от сквозняков и других негативных воздействий, которые сулит нам Российский климат.
            </p>
            <p class="bottom_half">Реализуемые нами в Самаре, и по Самарской области пластиковые окна не только успешно противостоят холоду, но и защищают помещение от жары — этому способствуют толщина профиля, «многослойное» стекло, наличие газа в камерах и, конечно, качественно выполненный монтаж.
            </p>
          </div>

          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main1.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">Удобство в эксплуатации
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Наша продукция исключительно удобна в эксплуатации. Для вашего удобства мы так же можем установить на окна ручки с ключом — это позволит обезопасить ваших детей от несчастных случаев.
                </p>
                <a href="/aboutus" class="readmor uppercase">
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main2.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">Доступность и безопасность
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Кроме того, доступны оконные системы в противовзломной фурнитурой, которая обеспечивает неприкосновенность вашего жилища, препятствуя проникновению в дом посторонних лиц.
                </p>
                <a href="/aboutus" class="readmor uppercase">
                </a>
              </div>
            </div>
          </div>

          <div class="col-md-12" style="padding-top: 50px; padding-bottom: 50px">
            <p class="bottom_half">Обратившись к нам за пластиковыми или алюминиевыми конструкциями, мы предоставим вам полнустью гарантийное и сервисное обслуживание, а также ряд дополнительных бонусов.
            </p>
            <p class="" style="font-size: 18px;font-weight: bold;color: #0060aa">Что вы получаете, заказывая пластиковые окна у нас:
            </p>
            <ol style="line-height: 220%">
              <li>1) <strong>Профессиональный подход</strong>, с учетом всех ваших пожеланий и особенностей помещения.</li>
              <li>2) <strong>Бесплатная консультация</strong> грамотных специалистов, инженера по замеру, наших менеджеров.</li>
              <li>3) <strong>Бесплатный Выезд</strong> на объект для проведения замеров, с возможностью заключение договора на дому.</li>
              <li>4) <strong>Высококачественные оконные конструкции</strong>, эксплуатационный срок которых составляет не менее 50 лет.</li>
              <li>5) <strong>Бесплатная Доставка</strong>, в удобное для вас время поднятие конструкций на этаж.</li>
              <li>6) <strong>Бесплатный Демонтаж</strong> старых конструкций при необходимости</li>
              <li>7) <strong>Монтаж оконной системы</strong>, в том числе стеклопакетов, подоконников, откосов, отливов. Монтажные бригады с опытом работы не менее 6-7 лет</li>
              <li>8) Гарантийное обслуживание и ремонт.</li>
              <li>9) <strong>Выгодное предложение</strong> по качеству и цене</li>
              <li>10) Различные <strong>Акции</strong> (в день замера дополнительно скидка) (скидка идёт на количество изделий и на объем)</li>
              <li>11) <strong>Подарки</strong> от нашей компании (детский замок,аптечка по уходу за окнами,москитная сетка и многое другое.</li>
              <li>12) <strong>Скидки</strong> % Пенсионером Льготникам Бюджетникам</li>
            </ol>
          </div>

          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main3.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">Качество, уют и надежность
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Наши клиенты: это люди которые ценят качество уют и надежность, нам доверяют уже многие, к нам идут люди которые ценят своё время, свой комфорт в доме.
                </p>
                <a href="/aboutus" class="readmor uppercase">
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main4.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">Большой ассортимент
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Мы остеклили сотни балконов, лоджий и окон по Самаре и Самарской области. Так же нашим преимуществом является большой ассортимент профильных систем ПВХ, Алюминиевых конструкций.
                </p>
                <a href="/aboutus" class="readmor uppercase">
                </a>
              </div>
            </div>
          </div>

          <div class="col-md-12" style="padding-top: 50px; padding-bottom: 50px">
            <p class="bottom_half">Различная палитра по цвету профиля, подоконников отливов, карнизов и других комплектующих и аксессуаров для окон. С нами вы останетесь не повторимы и довольны своими эстетично красивыми окнами, любой дизайн, любые сложные конструкции такие как арочные окна, треугольные, трапециевидные или круглые окна.
            </p>
            <p class="">Хотите получить всесторонний комфорт, уют и тишину в вашем доме? Пластиковые окна производства нашей компании помогут вам воплотить вашу мечту и идею в жизнь. За время нашей работы мы получили много положительных отзывов. Мы так же, как и вы заинтересованы в наилучшем результате и готовы предложить индивидуальный подход и надлежащий уровень обслуживания.
            </p>
          </div>

        </div>
      </div>
    </section>

      <!--Slogan-->
      <section id="slogan" class="padding_bottom">
        <br><br>
        <div class="container sloganBg">
          <div class="row">
            <div class="col-md-12">
              <div class="left">
                <h2 class="uppercase">
                  <span style="color: #30ade7">с чего начать?
                  </span> Закажите обратный звонок
                </h2>
                <p style="color:#0f0f0f">Оставьте свою заявку, и наш менеджер перезвонит Вам в ближайшее время
                </p>
              </div>
              <div class="right">
                <a href="#."
                   class="btn-common uppercase"
                   style="color:white;background:rgb(255, 16, 20);border:1px solid white!important;padding:14px"
                   @click.prevent="backCallShow = true"
                >
                  Заказать обратный звонок
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <back-call :visibility="backCallShow" @closeDialog="closeDialog"/>
    </div>
</template>

<script>
  import BackCall from './modals/BackCall.vue'
  export default {
    components: { BackCall },
    name: "Aboutus",
    data () {
      return {
        backCallShow: false,
      }
    },
    methods: {
      closeDialog() {
        this.backCallShow = false
      }
    }
  }
</script>

<style scoped>
a {
  color: #30ade7;
}
</style>
